import { Vehicle } from 'types/vehicle';
import { useListVehiclesOfferAuction } from './useListVehiclesOfferAuction';
import { getHighestBid } from 'utils/vehicle';

export const useListVehiclesHighestBid = (vehicle: Vehicle) => {
  const offerAuction = useListVehiclesOfferAuction(vehicle.id);

  if (vehicle.top_alternative_bid_offer) {
    const amount = vehicle.top_alternative_bid_offer.amount;
    return {
      bids: vehicle.alternative_bid_offers,
      bid: amount,
      proxy: vehicle.alternative_bid_offer,
      bidder: vehicle.top_alternative_bid_offer.bidder
    };
  }

  const offerBids = offerAuction?.offerBids || [];
  if (offerBids.length > 0) {
    return {
      bids: offerBids,
      bid: offerBids[0].amount,
      proxy: offerAuction?.offerProxyBid,
      bidder: offerBids[0].bidder
    };
  }

  const highestBid = getHighestBid(vehicle);

  if (highestBid.amount > 0) {
    return { bids: vehicle.bids, bid: highestBid.amount, bidder: highestBid.bidder, proxy: vehicle.proxy_bid };
  }

  return { bid: null, bidder: null, proxy: null, bids: [] };
};
